export function isValidEmail(email) {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function isValidDob(dob) {
	if (!/^\d{8}$/.test(dob)) return false;
	const day = +dob.slice(0, 2), month = +dob.slice(2, 4), year = +dob.slice(4);
	const d = new Date(year, month - 1, day);
	return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === day;
}
